export const constants = {
	VC_CLASS_POSTFIX: 'vc'
};



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/constants.js